import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import LangMenu from './LangMenu';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import {
  HEADER_LINKS as headerLinks,
  HEADER_CONTEST_LINKS as headerContestLinks,
  HEADER_AUTH_LINKS as headerAuthLinks,
  HEADER_MOBILE_LINKS as headerMobileLinks,
  SOCIAL_LINKS as socialLinks
} from '../../constants/navigation';

import { MAX_NAME_DISPLAY_LENGTH as maxNameLength } from '../../constants';

import { doSignOut, generateSsoUrl, getUsername } from '../../actions/auth';
import { setSignupFlow, toggleActiveAuthPopUp } from '../../actions/contest';

import { ellipsis } from '../../js/utility';

import iconDown from '../../images/icons/icon_downarrow.png';
import fgaLogo from '../../images/ford_logo_small.png';
// import sdacLogoMobile from '../../images/logo_sdac_v3.jpg';
// import sdacLogoDesktop from '../../images/logo_sdac_v4.png';
import sdacLogoBM from '../../images/logo_sdac_bm.png';
import sdacLogoCN from '../../images/logo_sdac_cn.png';

import iconBookings from '../../images/icons/icon_bookings.png';
import iconPassword from '../../images/icons/icon_password.png';
import iconLogout from '../../images/icons/icon_logout.png';
import iconToTop from '../../images/icons/icon_72_rightchev.png';

import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock';

import {withRouter} from 'react-router-dom';

let fetchedUsername = false;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isScrolled: false,
      isShowInfo: true,
      isHome: (window.location.pathname === '/getaways/' || window.location.pathname === '/getaways') ? true : false,
      isEverest: (window.location.pathname === '/getaways/everest/' || window.location.pathname === '/getaways/everest') ? true : false
    };
    this.lockRef = React.createRef();
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleMobileLinkClick = this.handleMobileLinkClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.flag = false;
    this.generateSso = this.generateSso.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isOpen } = this.state;
    const { user, getUsername } = this.props;

    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (window.location.pathname === '/getaways/' || window.location.pathname === '/getaways'){
        this.setState({isHome: true});
      }
      else{
        this.setState({isHome: false});
      }

      // check for Everest
      if (window.location.pathname === '/getaways/everest/' || window.location.pathname === '/getaways/everest'){
        this.setState({isEverest: true});
      }
      else{
        this.setState({isEverest: false});
      }
    }

    if (prevState.isOpen !== isOpen) {
      if (isOpen) {
        disableBodyScroll(this.lockRef.current);
      } else {
        enableBodyScroll(this.lockRef.current);
      }
    }

    if (user && !fetchedUsername) {
      getUsername();
      fetchedUsername = true;
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    clearAllBodyScrollLocks();
  }

  handleScroll() {
    let newFlag = window.pageYOffset > 80;
    if (this.flag !== newFlag) {
      this.setState({
        isScrolled: newFlag
      });
      this.flag = newFlag;
    }
  }

  handleMenuClick(e) {
    e.preventDefault();
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  handleMobileLinkClick() {
    this.setState({
      isOpen: false
    });
  }

  generateSso(method) {
    const { generateSsoUrl } = this.props;

    const xsrf = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
    generateSsoUrl(method, xsrf);
  }

  render() {
    const {
      signedIn,
      user,
      authType,
      doSignOut,
      i18n,
      t,
      userName,
      contestMode
    } = this.props;
    const { isOpen, isScrolled } = this.state;

    const username = user ? userName : '';

    const sdacLogoMobile = 'https://shop.sdacford.com.my/images/logo_sdac_2024.jpg';
    const sdacLogoDesktop = 'https://shop.sdacford.com.my/images/logo_sdac_2024_2.png';

    let localizedSdacLogo = sdacLogoDesktop;
    if (i18n.language === 'ms') {
      localizedSdacLogo = sdacLogoBM;
    } else if (i18n.language.toLowerCase() === 'zh-cn') {
      localizedSdacLogo = sdacLogoCN;
    }

    return (
      // <header className={`fe-header ${isScrolled ? 'scroll' : ''}`}>
      <header className={`fe-header ${this.state.isEverest ? 'everest' : ''}`}>
        {/* Covid 19 Header Popup */}
        {/* <div className={`info-header-wrapper ${this.state.isHome ? '':'hide'}`}>
          <div className='container info-header-content'>
            Important Information <div className={`info-button-div ${this.state.isShowInfo ? 'hide':''}`}><button onClick={() => this.setState({isShowInfo: !this.state.isShowInfo})} className='fe-header-info-button'>{this.state.isShowInfo ? 'Hide':'Show'}</button></div>
          </div>
        </div>
        <div className={`info-content-wrapper ${this.state.isShowInfo && this.state.isHome ? '':'hide'}`}>
          <div className='container info-content-container'>
            <div className='info-text-container'>
              Due to the recent rising cases of COVID-19,  certain experiences have been postponed. Please refer to the latest dates available in the experiences below.
            </div>
            <button className='fe-header-info-button color' onClick={() => this.setState({isShowInfo: !this.state.isShowInfo})}>Hide</button>
          </div>
        </div> */}
        <div className={`fe-scroll-top ${isScrolled ? 'display' : ''}`}>
          <button onClick={() =>
          {
            window.scrollTo({
              top: 0,
              behavior: 'smooth' // for smoothly scrolling
            });
          }}>
            <img src={iconToTop}></img>
          </button>
        </div>
        <div className='container'>
          <div className='fe-header-nav-container'>
            <div className='fe-header-logo '>
              {this.state.isEverest ? (
                <a href='https://www.sdacford.com.my/' className='d-flex'>
                  <img
                    className='fe-header-logo-img getLogo'
                    src={fgaLogo}
                    alt=''
                  />
                  <img
                    className='fe-header-logo-img mobileDisp'
                    src={sdacLogoDesktop}
                    alt=''
                  />
                </a>
              ) : (
                <NavLink exact to='/' activeClassName='active' className='d-flex'>
                  <img
                    className='fe-header-logo-img getLogo'
                    src={fgaLogo}
                    alt=''
                  />
                  <img
                    className='fe-header-logo-img mobileDisp'
                    src={sdacLogoDesktop}
                    alt=''
                  />
                </NavLink>
              )}
            </div>
            <nav className='fe-header-nav'>
              <ul className='fe-header-nav-main-links'>
                {!contestMode ? (
                  this.state.isEverest ? null : (
                  <>
                    {headerLinks.map((link, idx) => (
                      <li key={idx}>
                        <NavLink exact to={link.url} activeClassName='active'>
                          {t(`nav:${link.name}`)}
                        </NavLink>
                      </li>
                    ))}
                  </>
                  )
                ) : (
                  <>
                    {headerContestLinks.map((link, idx) => (
                      <li key={idx}>
                        <NavLink exact to={link.url} activeClassName='active'>
                          {t(`nav:${link.name}`)}
                        </NavLink>
                      </li>
                    ))}
                  </>
                )}
              </ul>
              <div className='fe-header-nav-right-content'>
                {!signedIn ? (
                  <ul className='fe-header-nav-auth-links'>
                    {this.state.isEverest ? null : (
                      <>
                        {headerAuthLinks.map((link, idx) => (
                          <li key={idx}>
                            <div
                              onClick={() => {
                                const {
                                  contestMode,
                                  setSignupFlow,
                                  showPopup,
                                  toggleActiveAuthPopUp
                                } = this.props;
                                if (!contestMode) {
                                  this.generateSso(link.method);
                                } else {
                                  if (!showPopup) {
                                    toggleActiveAuthPopUp(true);
                                    setSignupFlow(link.method);
                                  } else {
                                    setSignupFlow(link.method);
                                  }
                                }
                              }}
                            >
                              {t(`nav:${link.name}`)}
                            </div>
                            {/* <a
                              href={process.env.APP_SSO_URL + link.url}
                              className={
                                window.location.pathname === link.url
                                  ? 'active'
                                  : null
                              }
                            >
                              {t(`nav:${link.name}`)}
                            </a> */}
                          </li>
                        ))}
                      </>
                    )}
                  </ul>
                ) : (
                  <div className='fe-header-user'>
                    <span className='fe-header-username'>
                      {ellipsis(username, maxNameLength)}
                    </span>
                    <img src={iconDown} alt='' />
                    <ul className='fe-header-dropdown-links'>
                      {!contestMode && (
                        <li>
                          <Link to='/your-bookings'>
                            <img src={iconBookings} alt='' />
                            {t('nav:yourBookings')}
                          </Link>
                        </li>
                      )}
                      {authType === 'Standard' && !contestMode ? (
                        <li>
                          <div
                            onClick={() => this.generateSso('change-password')}
                          >
                            <img src={iconPassword} alt='' />
                            {t('nav:changePassword')}
                          </div>

                          {/* <Link to='/change-password'>
                            <img src={iconPassword} alt='' />
                            {t('nav:changePassword')}
                          </Link> */}
                        </li>
                      ) : null}
                      <li onClick={doSignOut}>
                        <Link to={`${contestMode ? '/contest' : '/'}`}>
                          <img src={iconLogout} alt='' />
                          {t('nav:logout')}
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
                {process.env.APP_ENV !== 'production' && !contestMode ? (
                  <LangMenu i18n={i18n} />
                ) : null}
              </div>
            </nav>
            {/* <div className="fe-header-ford">
                            <img src={fordLogo} alt=""/>
                        </div> */}
            <div className='fe-header-sdac'>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href='https://www.sdacford.com.my/'
              >
                <img src={sdacLogoDesktop} alt='' />
              </a>
            </div>
            <button
              onClick={this.handleMenuClick}
              className={`fe-header-nav-btn${isOpen ? ' active' : ''}`}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
        <nav
          className={`fe-header-nav mobile${isOpen ? '' : ' hide'}`}
          ref={this.lockRef}
        >
          <div className='fe-header-nav-mobile-container'>
            {this.state.isEverest ? null : (
              <>
                <div className='fe-header-nav-mob-auth'>
                  {!signedIn ? (
                    <div className='fe-header-nav-mob-auth-btns'>
                      {!contestMode ? (
                        <div
                          onClick={() => {
                            this.generateSso('signup');
                            this.handleMobileLinkClick();
                          }}
                          className='fe-u-btnlink'
                        >
                          {t('nav:signUp')}
                        </div>
                      ) : (
                        // <a
                        //   href={`${process.env.APP_SSO_URL}/signup`}
                        //   className='fe-u-btnlink'
                        //   onClick={this.handleMobileLinkClick}
                        // >
                        //   {t('nav:signUp')}
                        // </a>
                        <div
                          className='fe-u-btnlink'
                          onClick={() => {
                            const {
                              setSignupFlow,
                              showPopup,
                              toggleActiveAuthPopUp
                            } = this.props;
                            this.handleMobileLinkClick();
                            if (!showPopup) {
                              toggleActiveAuthPopUp(true);
                              setSignupFlow('signup');
                              setTimeout(function() {
                                document.body.style.overflow = 'hidden';
                              }, 100);
                            } else {
                              setSignupFlow('signup');
                              setTimeout(function() {
                                document.body.style.overflow = 'auto';
                              }, 100);
                            }
                          }}
                        >
                          {t('nav:signUp')}
                        </div>
                      )}

                      {!contestMode ? (
                        <div
                          onClick={() => {
                            this.generateSso('login');
                            this.handleMobileLinkClick();
                          }}
                          className='fe-u-btnlink'
                        >
                          {t('nav:login')}
                        </div>
                      ) : (
                        // <a
                        //   href={`${process.env.APP_SSO_URL}/login`}
                        //   className='fe-u-btnlink'
                        //   onClick={this.handleMobileLinkClick}
                        // >
                        //   {t('nav:login')}
                        // </a>
                        <div
                          className='fe-u-btnlink'
                          onClick={() => {
                            const {
                              setSignupFlow,
                              showPopup,
                              toggleActiveAuthPopUp
                            } = this.props;
                            this.handleMobileLinkClick();
                            if (!showPopup) {
                              toggleActiveAuthPopUp(true);
                              setSignupFlow('login');
                              setTimeout(function() {
                                document.body.style.overflow = 'hidden';
                              }, 100);
                            } else {
                              setSignupFlow('login');
                              setTimeout(function() {
                                document.body.style.overflow = 'auto';
                              }, 100);
                            }
                          }}
                        >
                          {t('nav:login')}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className='fe-header-nav-mob-user'>
                      <div className='fe-header-nav-mob-greeting'>
                        {t('nav:loggedAs')},<br />
                        <span>{username}</span>
                      </div>
                      <ul className='fe-header-nav-mob-user-links'>
                        {!contestMode && (
                          <li>
                            <Link
                              to='/your-bookings'
                              onClick={this.handleMobileLinkClick}
                            >
                              <img src={iconBookings} alt='' />
                              {t('nav:yourBookings')}
                            </Link>
                          </li>
                        )}
                        {authType === 'Standard' && !contestMode ? (
                          <li>
                            <div
                              onClick={() => {
                                this.handleMobileLinkClick();
                                this.generateSso('change-password');
                              }}
                            >
                              <img src={iconPassword} alt='' />
                              {t('nav:changePassword')}
                            </div>
                            {/* <Link
                              to='/change-password'
                              onClick={this.handleMobileLinkClick}
                            >
                              <img src={iconPassword} alt='' />
                              {t('nav:changePassword')}
                            </Link> */}
                          </li>
                        ) : null}
                        <li
                          onClick={() => {
                            this.handleMobileLinkClick();
                            doSignOut();
                          }}
                        >
                          <Link to={`${contestMode ? '/contest' : '/'}`}>
                            <img src={iconLogout} alt='' />
                            {t('nav:logout')}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                <ul>
                  {!contestMode ? (

                    this.state.isEverest ? null : (
                      <>
                        {headerMobileLinks.map((link, idx) => (
                          <li key={idx}>
                            <NavLink
                              onClick={this.handleMobileLinkClick}
                              exact
                              to={link.url}
                              activeClassName='active'
                            >
                              {t(`nav:${link.name}`)}
                            </NavLink>
                          </li>
                        ))}
                      </>
                    )

                  ) : (
                    <>
                      {headerContestLinks.map((link, idx) => (
                        <li key={idx}>
                          <NavLink
                            onClick={this.handleMobileLinkClick}
                            exact
                            to={link.url}
                            activeClassName='active'
                          >
                            {t(`nav:${link.name}`)}
                          </NavLink>
                        </li>
                      ))}
                    </>
                  )}

                  {process.env.APP_ENV !== 'production' && !contestMode ? (
                    <li className='fe-header-nav-mobile-lang'>
                      {/* <span>{t('gen:language')}:</span>
                      <LangMenu i18n={i18n} /> */}
                    </li>
                  ) : null}
                </ul>
              </>
            )}
            <div className='fe-header-nav-mob-bottom'>
              {/* <div className="fe-header-ford-mob">
                                <img src={fordLogo} alt="Ford"/>
                            </div> */}
              <a
                className='fe-header-sdac-mob'
                target='_blank'
                rel='noopener noreferrer'
                href='https://www.sdacford.com.my/'
              >
                <img className='' src={sdacLogoMobile} alt='SDAC' />
              </a>
              <div className='fe-header-nav-social'>
                <span>Follow Us</span>
                {socialLinks.map((link, idx) => (
                  <a
                    key={idx}
                    href={link.url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img src={link.iconAlt} alt={link.name} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  signedIn: PropTypes.bool.isRequired,
  user: PropTypes.object,
  authType: PropTypes.string,
  doSignOut: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  generateSsoUrl: PropTypes.func,
  location: PropTypes.object.isRequired
};

const mapStateToProps = ({ authState, contestState }) => ({
  user: authState.user,
  userName: authState.userName,
  authType: authState.authType,
  signedIn: authState.signedIn,
  contestMode: contestState.contestMode,
  showPopup: contestState.showPopup,

});

const mapDispatchToProps = {
  doSignOut,
  generateSsoUrl,
  setSignupFlow,
  toggleActiveAuthPopUp,
  getUsername
};

export default  withRouter(withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
));
